import { get } from '../utils/api';

export default class UnitFloorPlanHistoryService {
  getByUnitId(unitId: string) {
    return get(`/unit-floorplan-history/${unitId}`);
  }
}
